"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportImagesController = function ReportImagesController() {
  "ngInject";

  (0, _classCallCheck3.default)(this, ReportImagesController);
  var vm = this;
  vm.images = [];
  vm.zoom = [];

  vm.$onInit = function () {
    if (vm.resolve && vm.resolve.images) {
      vm.images = vm.resolve.images;
    }
  };
};

exports.default = ReportImagesController;


// WEBPACK FOOTER //
// ./client/app/common/reportImages/reportImages.controller.js